import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import * as React from 'react';
import S from './ImageBlock.styles';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
const ImageBlock = (props) => {
    if (!props.image) {
        return null;
    }
    const srcs = getSrcs(props.image, 1200, 375, 10);
    return (React.createElement(S.Container, { "data-layout": props.layout ?? 'default' },
        React.createElement(S.ImageWrapper, null,
            React.createElement(S.ImageLinkWrapper, { ...(props.imageLink
                    ? {
                        as: 'a',
                        href: props.imageLink.url,
                        target: props.imageLink.target || '_self',
                    }
                    : {}) },
                React.createElement(S.Image, { alt: props.image.altText ?? '', loading: "lazy", role: props.image.altText ? undefined : 'presentation', sizes: `${until(Device.SiteWidth)} 100vw, 1200px`, src: srcs[0].split(' ')[0], srcSet: srcs.join(',') })),
            props.caption && React.createElement(S.Caption, null, props.caption),
            props.ctaLink && props.ctaLink.url && props.ctaLink.text && (React.createElement(LinkButton, { buttonType: props.ctaTheme === 'light' ? 'default' : 'inverted', href: props.ctaLink.url, target: props.ctaLink.target }, props.ctaLink.text)))));
};
export default ImageBlock;
